// Content Configuration File
// Customize all text, labels, and messages from this central file

export const content = {
  // Company Information
  company: {
    name: 'Bounce Dads',
    tagline: '3 Dads. 1 Mission. Epic Fun',
    description: 'Safe, clean, and fun bounce houses for any occasion',
    logo: '/logo.png', // Default fallback - will be overridden by admin settings
    logoUrl: '', // Will be populated from admin settings
    contact: {
      email: 'support@bouncedadsatl.com',
      phone: '(404) 955-8126',
      serviceArea: 'We serve the greater Atlanta area and surrounding communities',
    },
    businessHours: {
      weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
      saturday: 'Saturday: 10:00 AM - 7:00 PM',
      sunday: 'Sunday: 10:00 AM - 6:00 PM',
    },
  },

  // Navigation
  navigation: {
    links: {
      home: 'Home',
      rentals: 'Rentals',
      contact: 'Contact Us',
      faq: 'FAQ',
      admin: 'Admin',
    },
    logo: {
      alt: 'Bounce Dads Logo',
    },
  },

  // Home Page
  home: {
    hero: {
      title: 'Welcome to Bounce Dads',
      subtitle: '3 Dads. 1 Mission. Epic Fun!',
      cta: {
        primary: 'View Rentals',
        secondary: 'Contact Us',
      },
    },
    features: {
      title: 'Why Choose Bounce Dads?',
      subtitle: 'Safe, clean, and fun premium bounce houses for any occasion',
      items: [
        {
          title: 'Quality Equipment',
          description: 'Commercial-grade bounce houses that are regularly inspected, cleaned, and maintained',
          icon: 'quality',
        },
        {
          title: 'Professional Service',
          description: 'Reliable delivery, setup, and pickup with excellent customer support',
          icon: 'service',
        },
        {
          title: 'Easy Booking',
          description: 'Simple online reservation system with instant availability checking',
          icon: 'booking',
        },
        {
          title: 'Fully Insured',
          description: 'Peace of mind with $300,000 liability insurance coverage',
          icon: 'insurance',
        },
      ],
    },
    aboutUs: {
      title: 'About Us',
      content: "We're three dads, longtime friends, and now proud owners of a bounce house company serving the Metro Atlanta area. What started as a way to bring more fun to our own kids' birthday parties quickly grew into a business built on family values, safety, and unforgettable memories.\n\nAs parents ourselves, we know how important it is to create safe, clean, and exciting experiences for our kids—and peace of mind for parents. That's why every bounce house and inflatable we offer is thoroughly cleaned, inspected, and delivered with care. Whether it's a backyard birthday bash, a school event, or a community festival, we're here to bring the bounce and the smiles.\n\nLet us help make your next event a blast—because fun is always better when it's shared.",
      teamImage: '/bouncedads2.png', // Using existing logo as placeholder for team photo
      teamImageAlt: 'Bounce Dads Team',
    },
    cta: {
      title: 'Ready to Make Your Event Special?',
      subtitle: 'Browse our selection of bounce houses and book your perfect rental today',
      button: 'Browse Rentals',
    },
  },

  // Rentals Page
  rentals: {
    title: 'Our Rentals',
    subtitle: 'Choose your perfect bounce house for your special event',
    dateSelection: {
      title: 'Select Your Rental Dates',
      pickupLabel: 'Pickup Date',
      dropoffLabel: 'Dropoff Date',
      selectPickup: 'Select pickup date',
      selectDropoff: 'Select dropoff date',
      selectPickupFirst: 'Select pickup date first',
      maxDaysNotice: 'Max {maxDays} days from pickup',
      rentalPeriod: 'Rental period: {startDate} - {endDate}',
    },
    productCard: {
      viewDetails: 'Click to view details and book',
      notAvailable: 'Not available for selected dates',
      selectDates: 'Select dates to check availability',
      checking: 'Checking availability...',
      perDay: '/day',
    },
    loading: {
      checkingAvailability: 'Checking availability...',
      noProducts: 'No products available at the moment.',
    },
  },

  // Product Details Page
  productDetails: {
    back: 'Back to Rentals',
    selectDates: 'Select Rental Dates',
    bookNow: 'Book Now',
    selectDatesFirst: 'Select dates first',
    checkingAvailability: 'Checking availability...',
    notAvailable: 'Not Available',
    available: 'Available for selected dates',
    rentalInfo: {
      title: 'Rental Information',
      option1: { main:'Standard rental times: 9:00 AM - 6:00 PM. Need different times?', subBullet1: 'Use the pick up next day addon to extend your rental time', subBullet2: 'Add your preferred schedule to the booking notes and we\'ll coordinate with you.'},
      option2: { main: 'Requires access to an electrical outlet within 100ft of the setup location.', subBullet1: 'Use the booking notes if you require a further extension cord or special setup requirements'},
      option3: { main: 'Cancellation policy:', subBullet1: '100% refund if cancelled 3 days prior to dropoff', subBullet2: 'If within 3 days of your event, a promo code will be issued for future rentals valid for 6 months from the date of the original booking.'},
      option4: { main: 'Payment Options:', subBullet1: 'Deposit (15% of total rental cost) with final payment due before the event',  subBullet2:'Full payment at time of booking.'},
    }
  },

  // Booking Page
  booking: {
    title: 'Customer Information',
    summary: {
      title: 'Rental Summary',
      product: 'Rental',
      rentalPeriod: 'Rental Period',
      dailyRate: 'Price per day',
      total: 'Total',
    },
    form: {
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      deliveryAddress: 'Delivery Address',
      streetAddress: 'Street Address',
      apartment: 'Apartment, suite, etc. (optional)',
      city: 'City',
      state: 'State',
      zipCode: 'ZIP Code',
      notes: 'Notes (Optional)',
      notesPlaceholder: 'Any special requests or notes about your booking',
    },
    buttons: {
      confirmBooking: 'Confirm Booking',
      creatingBooking: 'Creating Booking...',
      cancel: 'Cancel',
      backToRentals: 'Back to Rentals',
    },
    success: {
      title: 'Booking Confirmed!',
      message: 'Your booking for {productName} has been successfully created.',
    },
    loading: 'Loading booking information...',
  },

  // Contact Page
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch with us for any questions or booking inquiries',
    getInTouch: {
      title: 'Get in Touch',
      email: 'Email',
      phone: 'Phone',
      serviceArea: 'Service Area',
    },
    form: {
      title: 'Send Us a Message',
      name: 'Your Name',
      namePlaceholder: 'Enter your full name',
      email: 'Your Email',
      emailPlaceholder: 'Enter your email address',
      phone: 'Phone (Optional)',
      phonePlaceholder: 'Enter your phone number',
      message: 'Message',
      messagePlaceholder: 'Tell us about your event, rental needs, or any questions you have...',
      submit: 'Send Message',
      send: 'Send Message',
      sending: 'Sending...',
      successMessage: 'Message sent successfully! We\'ll get back to you soon.',
    },
    success: {
      message: 'Message sent successfully! We\'ll get back to you soon.',
    },
    error: {
      message: 'Failed to send message. Please try again.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      questions: [
        {
          question: 'What\'s included in the rental?',
          answer: 'All rentals include dropoff, setup, pickup, and a clean of the unit. Extension cords are provided within 100ft (can accommodate further distances with advance notice). \n\n Additional addons are available for each unit for an additional cost during booking (balloon arches, ball pit balls, etc.)',
        },
        {
          question: 'What are your standard rental times?',
          answer: 'Standard rental times are 9:00 AM - 6:00 PM.\n\n• We are flexible with timing - please add your preferred schedule to the booking notes and we will contact you to coordinate\n• Next day pickups are available for an additional charge (can be added as an addon during booking)',
        },
        {
          question: 'How far in advance should I book?',
          answer: 'We recommend booking at least 1-2 weeks in advance, especially for weekend events during peak season.',
        },
        {
          question: 'What are the safety requirements?',
          answer: 'We need a flat area free of debris with enough space for the unit (dimensions in the rental description), access to the location big enough for the unit, and access to a standard electrical outlet.',
        },
        {
          question: 'What if it rains?',
          answer: 'We offer free cancellations up to 3 days before your event. If within 3 days of your event, a promo code will be issued for future rentals valid for 6 months from the date of the original booking.',
        },
        {
          question: 'Are you insured?',
          answer: 'Yes! We are fully insured up to $300,000 for your peace of mind and protection.',
        },
      ],
    },
  },

  // Admin Pages
  admin: {
    navigation: {
      dashboard: 'Dashboard',
      products: 'Products',
      addons: 'Addons',
      bookings: 'Bookings',
      users: 'Users',
      settings: 'Settings',
    },
    login: {
      title: 'Admin Sign In',
      subtitle: 'Sign in to manage your bounce house rental business',
      username: 'Username',
      password: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in...',
      backToSite: '← Back to public site',
      invalidCredentials: 'Invalid credentials',
    },
    dashboard: {
      title: 'Admin Dashboard',
      welcome: 'Welcome back, {name}!',
      stats: {
        totalProducts: 'Total Products',
        totalBookings: 'Total Bookings',
        totalRevenue: 'Total Revenue',
        activeBookings: 'Active Bookings',
      },
    },
    products: {
      management: 'Products Management',
      create: 'Add New Product',
      edit: 'Edit Product',
      productName: 'Name',
      description: 'Description',
      price: 'Price',
      images: 'Images',
      uploadImages: 'Upload Images',
      removeImage: 'Remove Image',
      save: 'Save Product',
      cancel: 'Cancel',
      delete: 'Delete',
      noProducts: 'No products found.',
    },
    addons: {
      management: 'Addons Management',
      create: 'Add New Addon',
      edit: 'Edit Addon',
      name: 'Name',
      description: 'Description',
      price: 'Price',
      images: 'Images',
      uploadImages: 'Upload Images',
      removeImage: 'Remove Image',
      save: 'Save Addon',
      cancel: 'Cancel',
      delete: 'Delete',
      noAddons: 'No addons found.',
    },
    bookings: {
      management: 'Bookings Management',
      create: 'Create Booking',
      edit: 'Edit Booking',
      customer: 'Customer',
      product: 'Product',
      dates: 'Dates',
      status: 'Status',
      total: 'Total',
      actions: 'Actions',
      view: 'View',
      delete: 'Delete',
      sendContract: 'Send Contract',
      noBookings: 'No bookings found.',
    },
    users: {
      management: 'User Management',
      create: 'Add User',
      edit: 'Edit User',
      username: 'Username',
      email: 'Email',
      role: 'Role',
      actions: 'Actions',
      save: 'Save User',
      cancel: 'Cancel',
      delete: 'Delete',
      noUsers: 'No users found.',
    },
  },

  // Common Messages
  messages: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success!',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    select: 'Select',
    clear: 'Clear',
    apply: 'Apply',
    reset: 'Reset',
  },

  // Status Messages
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    completed: 'Completed',
    available: 'Available',
    unavailable: 'Unavailable',
    draft: 'Draft',
    published: 'Published',
  },

  // Validation Messages
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    minLength: 'Must be at least {min} characters',
    maxLength: 'Must be no more than {max} characters',
    numeric: 'Please enter a valid number',
    positive: 'Please enter a positive number',
    url: 'Please enter a valid URL',
    date: 'Please enter a valid date',
    time: 'Please enter a valid time',
  },

  // Accessibility Labels
  accessibility: {
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    previousImage: 'Previous image',
    nextImage: 'Next image',
    playVideo: 'Play video',
    pauseVideo: 'Pause video',
    openModal: 'Open modal',
    closeModal: 'Close modal',
    expand: 'Expand',
    collapse: 'Collapse',
    skipToContent: 'Skip to content',
  },
};

// Utility functions for content access
export const getContent = (path: string, params?: Record<string, string>) => {
  const keys = path.split('.');
  let value: any = content;

  for (const key of keys) {
    value = value[key];
    if (value === undefined) {
      console.warn(`Content path "${path}" not found in content config`);
      return '';
    }
  }

  // Replace parameters in the content
  if (typeof value === 'string' && params) {
    Object.entries(params).forEach(([key, val]) => {
      value = value.replace(new RegExp(`{${key}}`, 'g'), val);
    });
  }

  return value;
};

export default content;
